import {
  radioUI,
  radioSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

const educationLevels = {
  HS: 'A high school diploma',
  AD: 'An associate degree',
  BD: "A bachelor's degree",
  MD: "A master's degree",
  DD: 'A doctoral degree like a PhD',
};

const uiSchema = {
  ...titleUI('Your education'),
  highestLevelOfEducation: {
    ...radioUI({
      title: 'What’s the highest level of education you’ve completed?',
      labels: educationLevels,
    }),
  },
};

const schema = {
  type: 'object',
  required: ['highestLevelOfEducation'],
  properties: {
    highestLevelOfEducation: radioSchema(Object.keys(educationLevels)),
  },
};

export { schema, uiSchema };
